import { Line } from 'vue-chartjs'
import map from 'lodash/map'
import unique from 'lodash/uniq'
import flattenDeep from 'lodash/flattenDeep'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import maxBy from 'lodash/maxBy';
import forEach from 'lodash/forEach';
import toInteger from 'lodash/toInteger';
import lang from '../../../lang/translator';
import split from 'lodash/split';

export default {
  name: 'LineChart',
  extends: Line,
  props: {
    datasets: {
      required: true,
      type: [Array, Object],
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true,
    },
    yAxesBeginAtZero: {
      required: false,
      type: [Boolean],
      default: false,
    },
    animationDuration: {
      required: false,
      type: [Number],
      default: 0,
    },
    scaleLabel: {
      required: false,
      type: [Array, Object, String],
      default: function() {
        return {
          display: false,
        };
      },
    },
    yLabels: {
      required: true,
      type: [Array, Object],
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true,
    },
    stageInfo: null


  },
  mounted() {
    this.render();
  },
  plugins: [ChartDataLabels, chartjsPluginAnnotation],
  methods: {
    render() {
      let lastHoveredIndex = 0;

      let xLabels =  unique(flattenDeep(map(this.datasets,
          dataset => map(dataset.data, (item) => item.x))));


      let dataset = [];

      this.renderChart(
          {
            xLabels: xLabels,
            yLabels: this.yLabels,
            datasets: this.datasets,
          },
          {
            animation: {
              duration: this.animationDuration
            },
            layout: {
              padding: {
                left: 30,
                right: 40,
                top: 0,
                bottom: 0
              }
            },
            'onClick': (evt, item) => {
              if (item[0]) {
                let index = item[0]['_index'];
                let datasetIndex = item[0]['_datasetIndex'];
                let point = this.datasets[0].data[index];
                let label = this.datasets[0].label;
                this.$emit('popup-show', point, this.stageInfo,
                    lastHoveredIndex);
              }

            },
            responsive: true,
            tooltips: {
              callbacks: {
                // Use the footer callback to display the sum of the items showing in the tooltip
                label: function(tooltipItem, data) {
                  lastHoveredIndex = tooltipItem.datasetIndex;

                  return tooltipItem.yLabel;
                }
              },
            },
            maintainAspectRatio: this.aspectRatio,
            aspectRatio: this.aspectRatio ? 1.6 : false,
            showAllTooltips: true,
            legend: {
              display: this.showLegend,
              position: 'bottom',
            },
            scales: {
              yAxes: [{
                type: 'category',
                position: 'left',
                display: true,
                ticks: {
                  reverse: true
                },
                scaleLabel: {
                  display: true,
                  labelString: this.scaleLabel
                },
              }],
              xAxes: [{
                  ticks: {
                    display: !this.isMobile,
                    callback: function(dataLabel, index) {

                      let value = split(dataLabel, '_')
                      // Hide the text after _
                      return value[0];
                    }
                  },
                  scaleLabel: {
                    display: true,
                    labelString: lang.get('report.day_session')
                  }
                }
              ],
            },
            plugins: {
              datalabels: {
                backgroundColor: function(context) {
                  return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                align: 'end',
                offset: 8,
                display: false, /*function(context) {
                  let index = context.dataIndex;
                  let value = context.dataset.data[index];
                  return value.y > 0;
                },*/
                formatter: function(value, context) {
                  return value.x + ": " + value.y;
                }
              }
            },
          },

      )
    },
  },
  watch: {
    datasets() {
      this.render();
    }
  },

}



// WEBPACK FOOTER //
// ./src/common/chart/Component/LineNonNumericYChart.js